export default function NavbarHomeIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M428.62,175.55c0-4.72-2.34-9.11-6.3-11.71l-164.53-101.51c-2.35-1.56-5.06-2.33-7.76-2.33s-5.29.75-7.6,2.23l-164.65,98.76c-4.06,2.59-6.47,7.02-6.47,11.83l.06,253.13c0,7.75,6.3,14.05,14.06,14.05h118.34c7.26,0,13.15-5.89,13.15-13.15v-126.65h66.22v126.65c0,7.26,5.89,13.15,13.16,13.15h118.31c3.77,0,7.3-1.46,9.96-4.12,2.66-2.65,4.12-6.2,4.12-9.94l-.07-250.39ZM311.28,411.86v-125.73c0-7.76-6.31-14.07-14.07-14.07h-94.35c-7.76,0-14.08,6.31-14.08,14.07v125.73h-89.27l-.06-231.36,150.47-89.64,150.57,92.27.06,228.73h-89.27Z" />
    </svg>
  );
}
